var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"message-text",class:{ 'my-message': _vm.isMy }},[_vm._v(" "+_vm._s(_vm.message.body)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }